<template>
    <iframe
        v-if="url" 
        :src="url"
        width="100%" 
        :height="`${porlet.attr.height || '575'}px`" 
        frameborder="0" 
        style="border:0;" 
        allowfullscreen="" 
        aria-hidden="false" 
        tabindex="0"></iframe>
</template>

<script>
export default {
    name: 'Iframe',
    props: {
        porlet: {
            type: Object
        },
        entidad: String,
        id: String
    },
    data() {
        return {
            url: null
        }
    },
    mounted() {
        console.log(this.porlet.attr.url)

        /*let array = this.porlet.attr.url.split('?')
        let params = `${array[1]}&entidad=${this.entidad}&id=${this.id}`
        console.log(`${array[0]}?${params}`)

        this.url = `${array[0]}?${params}`*/

        this.url = this.porlet.attr.url
    }
}
</script>

<style lang="scss">
</style>
